import {
    Flex,
    Paragraph,
    pxArrayToRem,
    useStyles,
} from '@archipro-design/aria';

import * as S from './NoResultsSection.style';

interface NoResultsSectionProps {
    resultsType: 'products' | 'professionals' | 'projects' | 'suppliers';
}

export const NoResultsSection = (props: NoResultsSectionProps) => {
    const { resultsType } = props;
    const { css } = useStyles();

    return (
        <Flex column design={{ padding: pxArrayToRem([50, 50, 36, 50]) }}>
            <Paragraph design={{ margin: 0 }} className={css(S.TextStyle)}>
                {`Sorry, 0 ${resultsType} found.`}
            </Paragraph>

            <Paragraph design={{ margin: 0 }} className={css(S.TextStyle)}>
                Try changing the filters.
            </Paragraph>
        </Flex>
    );
};
